import ApiService from "./api.service";

const SliderService = {
  async sliders(userId) {
    try {
      const response = await ApiService.get(`user-slides/${userId}`);
      if (response?.status === 200) {
        return response;
      }
      return null;
    } catch (error) {
      return error.response || null;
    }
  },

  async banners() {
    try {
      return await ApiService.get(`default-banners`);
    } catch (e) {
      console.log(e);
    }
  },

  async mainBoxes(userId) {
    try {
      return await ApiService.get(`main-boxes/${userId}`);
    } catch (e) {
      console.log(e);
    }
  },
};

export { SliderService };
